(function (angular) {
  "use strict";

  angular.module('myApp').controller('galleryController',
    [
      '$scope', '$http',
      function ($scope, $http) {

        $scope.years = [];
        $scope.dto = null;
        $scope.paging = {};
        $scope.filters = {};
        $scope.filters.page = 1;
        $scope.filters.size = 12;
        $scope.isShowMoreButtonShow = false; 

        $scope.load = function () {

          $http.get('api/galleries/', {
            params: $scope.filters
          }).then(function (resp) {

            if (resp.data.data.length >= 12)
              $scope.isShowMoreButtonShow = true;
            else
              $scope.isShowMoreButtonShow = false;

            console.log($scope.isShowMoreButtonShow);
            console.log(resp.data.data.length);
            $scope.paging = resp.data.paging;
            $scope.list = resp.data.data;
          });
        };
        $scope.load();

        $scope.page = 1;
        $scope.TotalPage = 2;
       
        var width = $(window).width();
        var height = $(window).height();

        if (width > 767 && height > 500) {
          $(window).scroll(function () {
            (function () {
              var win = $(window);
              var sizes = {
                half: 0.5,
                full: 1,
                threequarter: 3 / 4,
                onefive: 1.5,
                double: 2,
                triple: 3
              };
              for (var k in sizes) {
                var v = sizes[k];
                $("." + k).css({
                  height: Math.floor(win.height() - 124 * v) + "px"
                });
              }

              $(".item").stick_in_parent({
                container: $(".latest-blog"),
                offset_top: 124
              });
            })();
          });
        }

        //$(window).on("scroll", function () {
        //  if ($(window).scrollTop() + $(window).height() >= $('#blogList').height()) {

        //    if ($scope.loading === true) {
        //      $scope.page = $scope.page + 1;

        //      if ($scope.TotalPage + 1 >= $scope.page) {
        //        $scope.goToPage($scope.page);
        //      }
        //    }
        //  }
        //});

        $scope.showMore = function () {
          $scope.filters.page = $scope.filters.page + 1;

          $http.get('api/galleries/', {
            params: $scope.filters
          }).then(function (resp) {
            if (resp.data.data.length >= 12)
              $scope.isShowMoreButtonShow = true;
            else
              $scope.isShowMoreButtonShow = false;

            console.log($scope.isShowMoreButtonShow);
            console.log(resp.data.data.length);
            $scope.list = $scope.list.concat(resp.data.data);
            $scope.TotalPage = resp.data.paging.total / $scope.filters.size;
          });
        };
      }
    ]);

}(window.angular));
